<template>
    <div>

        <div id="unity-container" class="unity-desktop">
            <canvas id="unity-canvas"></canvas>
        </div>
        <div id="loading-cover" style="display:none;">
            <div id="unity-loading-bar">
                <div id="unity-logo"><img src="logo.png"></div>
                <div id="unity-progress-bar-empty" style="display: none;">
                    <div id="unity-progress-bar-full"></div>
                </div>
                <div class="spinner"></div>
            </div>
        </div>
        <div id="unity-fullscreen-button" style="display: none;"></div>

        <videoPopup :videoUrl="videoUrl" @onClose="closeVideoOvl"></videoPopup>

    </div>
</template>

<script>
    import videoPopup from "./VideoPopup";
    import axios from 'axios';

    export default {
        name: 'Home',
        components: {
            videoPopup
        },
        data: function () {
            return {
                uInstance: null,
                isBrowserOk: true,
                userAgent: null,
                refreshTimeout: null,

                videoUrl: null,

                nickname: null,
                hasNickname: false
            }
        },
        computed: {
            isDev() {
                return process.env.NODE_ENV !== 'production';
            },

            initialQuery() {
                return this.$store.getters.initialQuery;
            },
            initialToken() {
                return this.$store.getters.initialToken;
            },
            currentUserNickname() {
                return this.$store.state.nickname;
            },
        },
        methods: {
            //setWebGLInputFocus(isExternalAction) {
            //    let webGlKeyInputEnabled = isExternalAction ? 0 : 1;
            //    console.log('CaptureAllKeyboardInput', webGlKeyInputEnabled);
            //    this.uInstance.SendMessage('VExpoSiteKeyboardInputControllerObject', 'CaptureAllKeyboardInput', webGlKeyInputEnabled);
            //},
            getNickname() {
                return axios.get(process.env.VUE_APP_GET_NICKNAME)
                    .then(response => {
                        if (!response.data.Nickname) {
                            this.nickname = null;
                            this.hasNickname = false;
                        }
                        else {
                            this.nickname = response.data.Nickname;
                            this.hasNickname = true;
                        }
                    })
                    .catch(() => {
                        this.hasNickname = false;
                    });
            },
            closeVideoOvl() {
                this.videoUrl = null;
                //TODO: chiamare la funzione JS che mi dice revera...

            },
            isMobile() {
                return /Android|webOS|BlackBerry|webOS|Windows Phone|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
            isIOS() {
                return /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
            }
        },
        watch: {
        },
        beforeMount: function () {
            let p01 = this.getNickname();
            Promise.all([p01])
                .then(response => {
                    if (this.hasNickname) {
                        /*WebGL 2.0 https://caniuse.com/#search=webgl%202.0 */
                        this.isBrowserOk = (
                            (this.$browserDetect.isFirefox === true && this.$browserDetect.meta.version >= 75) ||
                            (this.$browserDetect.isEdge === true && this.$browserDetect.meta.version >= 83) ||
                            (this.$browserDetect.isChrome === true && this.$browserDetect.meta.version >= 80)
                        );

                        this.userAgent = window.navigator.userAgent;
                    } else {
                        let param = this.$store.getters.initialQuery;
                        this.$router.push({ name: 'LoginNickname', params: param });
                    }
                });
        },
        mounted: function () {
            //this.uInstance = window.UnityLoader.instantiate('unityContainer', 'Build/Vexpo.json', { onProgress: this.unityProgress });

            /* */
            let $vm = this;
            function createVariables() {
                let result = "";

                let baseUrl = location.protocol + "//" + location.host + "/";
                if ($vm.initialQuery && $vm.initialQuery.hasOwnProperty('fair')) {
                    let fairVal = $vm.initialQuery['fair'];
                    let fairNumber = parseInt(fairVal)
                    if (!isNaN(fairNumber)) {
                        result = "m," + fairNumber;                        
                    }
                    window.history.replaceState("", "", baseUrl + "?fair=" + fairVal);
                }
                if ($vm.initialQuery && $vm.initialQuery.hasOwnProperty('action')) {
                    let actionVal = $vm.initialQuery['action'];
                    if (actionVal === 'stand') {
                        result = "s,0";
                    }
                    else if (actionVal === 'admin') {
                        result = "f,0";
                    }
                    window.history.replaceState("", "", baseUrl + "?action=" + actionVal);
                }

                let body = document.querySelector("body");
                let resultContainer = document.createElement("div");
                resultContainer.id = "spawnData";
                resultContainer.style.display = "none";
                resultContainer.style.visibility = "hidden";
                if (result) {
                    resultContainer.innerHTML = "valore:" + result;
                }
                body.appendChild(resultContainer);

                let tokenContainer = document.createElement("div");
                tokenContainer.id = "spawnToken";
                tokenContainer.style.display = "none";
                tokenContainer.style.visibility = "hidden";
                if ($vm.initialToken) {
                    tokenContainer.innerHTML = $vm.initialToken;
                }
                body.appendChild(tokenContainer);
            }
            createVariables();
            /* */

            const hideFullScreenButton = "";
            const buildUrl = $vm.isMobile() ? process.env.VUE_APP_WEBGL_BUILD_URL_MOBILE : ($vm.isIOS() ? process.env.VUE_APP_WEBGL_BUILD_URL_IOS : process.env.VUE_APP_WEBGL_BUILD_URL);
            const loaderUrl = buildUrl + process.env.VUE_APP_WEBGL_LOADER_URL;
            const config = {
                dataUrl: buildUrl + process.env.VUE_APP_WEBGL_DATA_URL,
                frameworkUrl: buildUrl + process.env.VUE_APP_WEBGL_FRAMEWORK_URL,
                codeUrl: buildUrl + process.env.VUE_APP_WEBGL_CODE_URL,
                streamingAssetsUrl: $vm.isMobile() ? process.env.VUE_APP_WEBGL_STREAMING_ASSERS_URL_MOBILE : ($vm.isIOS() ? process.env.VUE_APP_WEBGL_STREAMING_ASSERS_URL_IOS : process.env.VUE_APP_WEBGL_STREAMING_ASSERS_URL),
                companyName: "VExpo",
                productName: "VExpo",
                productVersion: "1.0.0",
            };
            if ($vm.isMobile()) {

            }
            const container = document.querySelector("#unity-container");
            const canvas = document.querySelector("#unity-canvas");
            const loadingCover = document.querySelector("#loading-cover");
            const progressBarEmpty = document.querySelector("#unity-progress-bar-empty");
            const progressBarFull = document.querySelector("#unity-progress-bar-full");
            const fullscreenButton = document.querySelector("#unity-fullscreen-button");
            const spinner = document.querySelector('.spinner');

            const canFullscreen = (function () {
                for (const key of [
                    'exitFullscreen',
                    'webkitExitFullscreen',
                    'webkitCancelFullScreen',
                    'mozCancelFullScreen',
                    'msExitFullscreen',
                ]) {
                    if (key in document) {
                        return true;
                    }
                }
                return false;
            }());

            if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                container.className = "unity-mobile";
                config.devicePixelRatio = 1;

                //if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                    var w = window.innerWidth;
                    var h = window.innerHeight;
                    container.style.width = w + "px";
                    container.style.height = h + "px";
                //}
            }
            loadingCover.style.display = "";

            const script = document.createElement("script");
            script.src = loaderUrl;
            script.onload = () => {
                createUnityInstance(canvas, config, (progress) => {
                    spinner.style.display = "none";
                    progressBarEmpty.style.display = "";
                    progressBarFull.style.width = `${100 * progress}%`;
                }).then((unityInstance) => {
                    loadingCover.style.display = "none";
                    if (canFullscreen) {
                        if (!hideFullScreenButton) {
                            fullscreenButton.style.display = "";
                        }
                        fullscreenButton.onclick = () => {
                            window.vuplex.SetFullscreen(1)/*https://support.vuplex.com/articles/webgl-fullscreen*/;
                        };
                    }
                }).catch((message) => {
                    alert(message);
                });
            };
            document.body.appendChild(script);


            window.ToggleIFrameVideo = function (url) {
                $vm.videoUrl = url ? url : null;
            };
        },
        beforeDestroy() {
            clearTimeout(this.refreshTimeout);
        }
    }
</script>

<style scoped>
</style>